var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8.80006 11.2C8.80006 11.6418 8.44188 12 8.00006 12C7.55823 12 7.20006 11.6418 7.20006 11.2V7.19997C7.20006 6.75814 7.55823 6.39997 8.00006 6.39997C8.44188 6.39997 8.80006 6.75814 8.80006 7.19997V11.2ZM7.20006 4.8C7.20006 5.24183 7.55823 5.6 8.00006 5.6C8.44188 5.6 8.80006 5.24183 8.80006 4.8C8.80006 4.35817 8.44188 4 8.00006 4C7.55823 4 7.20006 4.35817 7.20006 4.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.6c6d139c84953d84e5a2e8fdf9c40bec.svg";
export { ForwardRef as ReactComponent };